import {AB_TEST_COOKIES} from './types';

export const extendWithAbTests = (
  storage: Record<string, string>,
  abTestHeader: string | undefined,
) => {
  if (!abTestHeader || abTestHeader.length === 0) {
    return storage;
  }

  return {
    ...storage,
    [AB_TEST_COOKIES.Experiments]: abTestHeader,
  };
};
